import { fromJS } from 'immutable';

import { loadSession } from 'data/CurrentUser/sessionManager';

import * as constants from 'data/CurrentUser/constants';

export const initialState = fromJS({
  bearerToken: loadSession(),
});

function currentUserReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_CURRENT_USER:
      return state.set('session', {
        bearerToken: action.bearerToken,
        remember: action.remember,
        expiry: action.expiry,
      });
    case constants.UNSET_CURRENT_USER:
      return state
        .set('session', undefined);
    case constants.SET_CURRENT_ME:
      return state
        .set('me', fromJS(action.me));
    case constants.UNSET_CURRENT_ME:
      return state
        .set('me', undefined);
    default:
      return state;
  }
}

export default currentUserReducer;
